import React, { useState, useEffect, useRef } from 'react';
import { Container } from '@mui/system';
import SwitchComponent from 'src/components/shared/Form/Switch';
import DateTimePicker from 'src/components/App/DatePicker';
import {
  StyledBox, GreetingTypography, ClinicTypography, SwitchContainer, CloseTypography, FilterIcon
  , OpenTypography,
  GreetingBox,
  GreetingBoxTypography1,
  GreetingBoxTypography2,
  ThreeContent,
  Box1,
  Box2,
  SearchBox,
  SearchIcon,
  TableViewIcon,
  CardViewIcon,
  ToggleBox,
  ToggleSlider,
  ToggleIconWrapper,
  FilterIconContainer,
  ButtonAvatar
} from './styles';

import Filter from '../../../../assets/images/filter 2.svg';
import Search from '../../../../assets/images/search-normal.svg';
import theme, { palette } from 'src/config/theme';
import {
  Divider, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  alpha,
  Tooltip,
  keyframes,
  useMediaQuery
} from '@mui/material';
import { useTheme } from "@mui/material/styles";
import InputComponent from 'src/components/shared/Form/Input';
import { ReactComponent as TableIcon } from '../../../../assets/images/grid-7.svg';
import { ReactComponent as CardIcon } from '../../../../assets/images/grid-8.svg';
import ButtonComponent from 'src/components/shared/Button';
import AddAppointment from '../LefSidebarForms/AddAppointment/AddAppointment';
import AddPatient from '../LefSidebarForms/AddPatient/AddPatient';
import AddTask from '../LefSidebarForms/AddTask/AddTask';
import AddBilling from '../LefSidebarForms/AddBilling/AddBilling';
import { ReactComponent as AddIcon } from '../../../../assets/images/add-square.svg';
import { ReactComponent as Clock } from '../../../../assets/images/clock.svg';
import { Box, Menu, MenuItem } from '@mui/material';
import storage from 'src/utils/storageUtils';
import AddStaff from '../LefSidebarForms/AddStaff/AddStaff';
import AddClinic from '../LefSidebarForms/AddClinic/AddClinic';
import { ReactComponent as Calendar } from '../../../../assets/images/calendar.svg';
import { ReactComponent as More } from '../../../../assets/images/more.svg'
import { shadows } from 'src/config/theme';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import useResponsive from 'src/components/hooks/useResponsive';
import ClearIcon from '@mui/icons-material/Clear';
import { useSelector } from 'react-redux';
import { isSanginiRestrictedUser } from 'src/utils/sanginiUtils';

const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const Welcome = ({ category = '', setIsCardView, isCardView, updateAppointments, updatePatients, updateStaff, updateClinics, updateTask, updateBilling, handleSearch, selectedDate, setSelectedDate, selectedStatus, setSelectedStatus }) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const theme = useTheme();
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

  const drawerWidth = '280px'
  const DoctorName = storage.get('DOCTORNAME');
  const [open, setOpen] = useState(false);
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElDate, setAnchorElDate] = useState(null);
  const [anchorElStatus, setAnchorElStatus] = useState(null);
  const [menuType, setMenuType] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDateDialogOpen, setIsDateDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date());

  // Live Clock effect
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 60000); // update every minute
    return () => clearInterval(timer);
  }, []);

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return { text: 'Good Morning', emoji: '🌅' };
    if (hour < 17) return { text: 'Good Afternoon', emoji: '☀️' };
    if (hour < 21) return { text: 'Good Evening', emoji: '🌇' };
    return { text: 'Good Night', emoji: '🌙' };
  };
  const { text: greetingText, emoji: greetingEmoji } = getGreeting();

  const isInitialMount = useRef(true);

  // Debounce search effect
  useEffect(() => {
    if (handleSearch) {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }
      const handler = setTimeout(() => {
        handleSearch(searchTerm);
      }, 500); 
      return () => clearTimeout(handler);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const user = useSelector((state) => state.auth?.user);
  const isSangini = isSanginiRestrictedUser(user);

  // Keyboard Shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      const tagName = document.activeElement?.tagName;
      if (tagName === 'INPUT' || tagName === 'TEXTAREA') return;

      if (e.key === '/') {
        e.preventDefault();
        const searchInput = document.getElementById('global-search-input');
        if (searchInput) {
          searchInput.focus();
        }
      } else if (e.key.toLowerCase() === 'n') {
        if (isSangini || category === 'clinics' || category === 'staff') {
          return;
        }
        e.preventDefault();
        handleOpen();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [category, isSangini]);

  const handleToggle = (View) => {
    setIsCardView(View)
  }
  const message = {
    appointments: isMobile || isTablet ? 'List of all your appointments!' : 'Here are list of all your appointments!',
    patients: isMobile || isTablet ? 'Here are list of all your patients!' : 'List of all your patients!',
    staff: isMobile || isTablet ? 'Here are list of all your staff!' : 'List of all your staff!',
    tasks: isMobile || isTablet ? 'Here are list of all your tasks!' : 'List of all your tasks!',
    clinics: isMobile || isTablet ? 'Here are list of all your clinics!' : 'List of all your clinics!',
    billing: isMobile || isTablet ? 'Here are list of all your billing!' : 'List of all your billing!',
    reviews: isMobile || isTablet ? 'Here are list of all your reviews!' : 'List of all your clinic reviews!',
    Dashboard: 'Welcome To Dashboard!',
  }
  const btnTxt = {
    appointments: 'Add Appointment',
    patients: 'Add Patient',
    staff: 'Add Staff',
    tasks: 'Add Task!',
    clinics: 'Add clinic',
    billing: 'Add Billing',
  }
  const greetingSubMessage = message[category] || 'Welcome!';
  const AddBtn = btnTxt[category] || 'Add Data';
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const formComponents = {
    appointments: <AddAppointment onClose={handleClose} updateAppointments={updateAppointments} />,
    patients: <AddPatient onClose={handleClose} updatePatients={updatePatients} />,
    staff: <AddStaff onClose={handleClose} updateStaff={updateStaff} />,
    clinics: <AddClinic onClose={handleClose} updateClinics={updateClinics} />,
    tasks: <AddTask onClose={handleClose} updateTask={updateTask} />,
    billing: <AddBilling onClose={handleClose} updateBilling={updateBilling} />
  }

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleOpenDateDialog = (event) => {
    setAnchorElDate(event.currentTarget);
    setIsPickerOpen(true);

  };
  const handleCloseDateDialog = () => {
    setAnchorElDate(null);
    setIsPickerOpen(false);
  };

  const handleOpenStatusMenu = (event) => {
    setAnchorElStatus(event.currentTarget);
  };

  const handleCloseStatusMenu = () => {
    setAnchorElStatus(null);
  };
  const handleOpenMenu = (event, type) => {
    setAnchorEl(event.currentTarget);
    setMenuType(type);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuType(null);
  };

  const settings = [
    { label: 'Date', icon: <Calendar width={22} />, action: (e) => handleOpenMenu(e, 'date') },
    { label: 'Record Status', icon: <More width={22} />, action: (e) => handleOpenMenu(e, 'status') },

  ];
  const [isPermanentOpen, setIsPermanentOpen] = useState(storage.get('IsPermanentOpen') === 'true');

  useEffect(() => {
    const handleStorageChange = () => {
      setIsPermanentOpen(storage.get('IsPermanentOpen') === 'true');
    };
    window.addEventListener('sidebarToggled', handleStorageChange);
    return () => window.removeEventListener('sidebarToggled', handleStorageChange);
  }, []);

  return (
    <Container maxWidth="xxl" disableGutters >
      <StyledBox sx={{
        backgroundColor: alpha('#FFF', 0.8),
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${alpha(theme.palette.gery.black, 0.05)}`,
        position: 'fixed',
        left: {
          xs: 0,
          sm: 0,
          md: isPermanentOpen ? '280px' : '90px',
        },
        right: 0,
        top: isMobile || isTablet ? '72px' : '84px',
        zIndex: 1100,
        paddingLeft: { xs: '16px', lg: '32px' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pr: { xs: 2, lg: 4 }
      }}>
        <GreetingBox isMobile={isMobile} isTablet={isTablet}>
          <GreetingBoxTypography1 sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            {greetingText}, 
            <Box 
              component="span"
              sx={{ 
                background: 'linear-gradient(270deg, #1e3c72, #2a5298, #ff6b6b, #4a00e0)',
                backgroundSize: '800% 800%',
                animation: `${gradientShift} 8s ease infinite`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontWeight: 800,
                letterSpacing: '-0.5px'
              }}
            >
              {DoctorName}
            </Box> {greetingEmoji}
          </GreetingBoxTypography1>
          <GreetingBoxTypography2 sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ display: { xs: 'none', lg: 'inline' } }}>
              {greetingSubMessage}
            </Box>
            <span style={{ fontSize: '12px', opacity: 0.8, backgroundColor: alpha(theme.palette.primary.main, 0.1), padding: '2px 8px', borderRadius: '12px', fontWeight: 600 }}>
              {currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </span>
          </GreetingBoxTypography2>
        </GreetingBox>
        <ThreeContent>
          <Box1>
            {setSelectedDate && setSelectedStatus && (
              <FilterIconContainer 
                onClick={handleOpenUserMenu}
                active={Boolean(selectedDate || selectedStatus)}
              >
                <FilterIcon
                  src={Filter}
                />
              </FilterIconContainer>
            )}
            {handleSearch && isDesktop && (
              <SearchBox sx={{ 
                position: 'relative', 
                transition: 'all 0.3s ease', 
                '&:focus-within': { 
                  boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.2)}`,
                  transform: 'scale(1.02)'
                } 
              }}>
                <SearchIcon src={Search} />
                <InputComponent
                  id="global-search-input"
                  placeholder="Search (Press / )"
                  variant="outlined"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                      setSearchTerm('');
                      e.target.blur();
                    }
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused": {
                         boxShadow: 'none',
                         transform: 'none',
                      },
                      "& fieldset": {
                        border: "none",
                        width: 'auto'
                      },
                      "& input": {
                        paddingLeft: 0,
                        paddingRight: '30px', 
                        height: '100%'
                      },
                    },
                  }} />
                  {searchTerm && (
                    <ClearIcon 
                      onClick={() => setSearchTerm('')}
                      sx={{
                        position: 'absolute',
                        right: '12px',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: alpha(theme.palette.gery.black, 0.4),
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          color: theme.palette.primary.main,
                          transform: 'scale(1.2) rotate(90deg)'
                        }
                      }}
                    />
                  )}
              </SearchBox>
            )}
          </Box1>
          {isDesktop && (
            <Divider orientation='vertical' />

          )}

          <Box2>
            {isDesktop && category !== 'reviews' && (
              <ToggleBox>
                <ToggleSlider isCardView={isCardView} />
                <ToggleIconWrapper active={!isCardView} onClick={() => handleToggle(false)}>
                  <TableIcon style={{ color: !isCardView ? theme.palette.primary.main : alpha(theme.palette.gery.black, 0.4), transition: 'color 0.3s' }} />
                </ToggleIconWrapper>
                <ToggleIconWrapper active={isCardView} onClick={() => handleToggle(true)}>
                  <CardIcon style={{ color: isCardView ? theme.palette.primary.main : alpha(theme.palette.gery.black, 0.4), transition: 'color 0.3s' }} />
                </ToggleIconWrapper>
              </ToggleBox>
            )}
            {category !== 'staff' && category !== 'reviews' && (
              (isMobile || isTablet || isLgDown) ? (
                <ButtonAvatar
                  onClick={isSangini ? undefined : handleOpen}
                  sx={isSangini ? { opacity: 0.5, cursor: 'not-allowed !important', pointerEvents: 'none' } : {}}
                >
                  <AddIcon width={20} height={20} />
                </ButtonAvatar>
              ) : (
                <Tooltip title={isSangini ? "You don't have permission to add appointments" : `Add ${category === 'patients' ? 'Patient' : 'Data'} (Press N)`} placement="top" arrow>
                  <span>
                    <ButtonComponent
                      variant="outlined"
                      startIcon={<AddIcon
                        width={24} height={24}

                        sx={{ color: theme.palette.primary.main }} />}
                      sx={{
                        width: '207px',
                        height: '52px',
                        borderRadius: '12px',
                        padding: '10px 18px',
                        bgcolor: (category === 'clinics' || category === 'staff' || isSangini) ? theme.palette.gery.light3 : theme.palette.primary.main,
                        border: `1px solid ${theme.palette.primary.light1}`,
                        color: theme.palette.gery.white,
                        cursor: (category === 'clinics' || category === 'staff' || isSangini) ? 'not-allowed !important' : 'pointer',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                          color: theme.palette.primary.main,
                          backgroundColor: (category === 'clinics' || category === 'staff' || isSangini) ? theme.palette.gery.light3 : theme.palette.gery.white,
                          boxShadow: (category === 'clinics' || category === 'staff' || isSangini) ? 'none' : '0 8px 16px rgba(0,0,0,0.1)',
                          transform: (category === 'clinics' || category === 'staff' || isSangini) ? 'none' : 'translateY(-2px)',
                        },
                        '&:active': {
                          transform: (category === 'clinics' || category === 'staff' || isSangini) ? 'none' : 'translateY(1px)',
                        }
                      }}
                      onClick={isSangini ? undefined : handleOpen}
                      disabled={category === 'clinics' || category === 'staff' || isSangini}
                    >
                      {AddBtn}
                    </ButtonComponent>
                  </span>
                </Tooltip>
              )
            )}
          </Box2>
        </ThreeContent>
      </StyledBox>

      <DialogBox
        open={open}

      >
        {formComponents[category] || (
          <Typography variant="body1">
            No form available for this category.
          </Typography>
        )}

      </DialogBox>

      <Menu
        PaperProps={{
          sx: {
            backgroundColor: palette.gery.white,
            boxShadow: shadows[4],
            borderRadius: '12px',
            border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
          },
        }}
        anchorEl={anchorElUser}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting) => (
          <MenuItem key={setting.label} onClick={setting.action}>
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {setting.icon}
              {setting.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        PaperProps={{
          sx: {
            backgroundColor: palette.gery.white,
            boxShadow: shadows[4],
            borderRadius: '12px',
            border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
          },
        }}
        sx={{
          mt: isMobile ? '10px' : '-20px',
          marginLeft: isMobile ? '10px' : '140px',
        }}
      >
        {menuType === 'date' && (
          <>
            <MenuItem
              sx={{ '&:hover': { backgroundColor: 'transparent !important' } }}
            >
              <DateTimePicker
                type="date"
                value={selectedDate}
                onChange={(date) => {
                  setSelectedDate(date);
                }}
                onAccept={() => handleCloseMenu()}
                sx={{ width: '100%' }}
              />
            </MenuItem>

            {selectedDate && (
              <MenuItem
                onClick={() => {
                  setSelectedDate(null);
                  handleCloseMenu();
                }}
              >
                <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                  Clear Date
                  <ClearIcon fontSize="small" />
                </Typography>
              </MenuItem>
            )}
          </>
        )}

        {menuType === 'status' && (
          ['All', 'Scheduled', 'In Queue', 'Attending Now', 'Complete', 'Cancelled', 'Treatment Scheduled', 'Overdue'].map((status) => (
            <MenuItem
              key={status}
              onClick={() => {
                setSelectedStatus(status === 'All' ? '' : status);
                handleCloseMenu();
              }}
            >
              {status}
            </MenuItem>
          ))
        )}
      </Menu>
    </Container >
  );
};

export default Welcome;